import { DateTime } from 'luxon';
import * as powerbi from 'powerbi-client';
import slicer from '../slicerReports/ERCOT4CPSlicer.js';

const regex = /\bDate Slicer\b/gi;

// Embed a Power BI report in the given HTML element with the given configurations
// Read more about how to embed a Power BI report in your application here: https://go.microsoft.com/fwlink/?linkid=2153590
const getEmbed = async (container, configuration) => {
  /*-----------------------------------------------------------------------------------+
    |    Don't change these values here: access token, embed URL and report ID.          | 
    |    To make changes to these values:                                                | 
    |    1. Save any other code changes to a text editor, as these will be lost.         |
    |    2. Select 'Start over' from the ribbon.                                         |
    |    3. Select a report or use an embed token.                                       |
    +-----------------------------------------------------------------------------------*/
  // Embed the report and display it within the div container.
  const pbi = new powerbi.service.Service(
    powerbi.factories.hpmFactory,
    powerbi.factories.wpmpFactory,
    powerbi.factories.routerFactory
  );

  const report = pbi.embed(container, configuration);

  // report.on will add an event handler
  report.on('loaded', async function () {
    try {
      report.off('loaded');
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  report.on('rendered', async () => {
    try {
      const pages = await report.getPages();
      // Retrieve the active page.
      const [pageWithSlicer] = pages.filter((page) => {
        return page.isActive;
      });
      // Retrieve the visuals so we have access to page elements
      const visuals = await pageWithSlicer.getVisuals();
      // Retrieve the Date Slicer
      const [dateSlicerVisual] = visuals.filter((visual) => {
        return visual.type === 'slicer' && regex.test(visual.title);
      });
      // Retrieve current parameters of slicer
      if (!dateSlicerVisual) return;
      const state = await dateSlicerVisual.getSlicerState();
      // Format the date slicers so that they are in utc time
      const newStartDate = DateTime.fromISO(state.filters[0].conditions[0].value).setZone('utc');
      const newEndDate = DateTime.fromISO(state.filters[0].conditions[1].value).setZone('utc');
      // Save the new start/end dates as part of the report parameters
      configuration.reportParameters.StartDate = newStartDate;
      configuration.reportParameters.EndDate = newEndDate;
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  report.on('pageChanged', async () => {
    try {
      const pages = await report.getPages();
      // Retrieve the active page.
      const [pageWithSlicer] = pages.filter((page) => {
        return page.isActive;
      });
      // set the slicers again for the new active page
      if (pageWithSlicer.displayName === 'Details') {
        const visuals = await pageWithSlicer.getVisuals();
        await slicer.setOvertimeSlicer(configuration.reportParameters, visuals);
      }
    } catch (errors) {
      return Promise.reject(errors);
    }
  });

  return report;
};

export default {
  getEmbed,
};
